import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Without this, tailwind-merge doesn't recognize the design system's custom
// font-size scale (text-h1..h5, text-body, etc. — defined in
// styles/tailwind-theme.css) as font-size utilities. It falls back to
// classifying them as text-color, so any class list combining e.g. "text-h4"
// with a real color class like "text-text-general-neutral-mid" silently drops
// the font-size class instead of merging both.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "body",
            "small",
            "xxs",
            "2xs",
            "mono-body",
            "mono-small",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/***
 *
 *   CLASSHELPER
 *   Helper function for applying SCSS or Tailwind classes
 *
 *   PARAMS
 *   debug: log the output to the console (boolean, optional)
 *   props: props object (object, required)
 *   styles: SCSS or tailwind styles (required)
 *
 **********/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ClassHelper(styles: any, props: any, debug: boolean) {
  let str = "";

  if (typeof styles === "object") {
    if (styles.base) str += styles.base; // always apply base styles

    if (Object.keys(props).length) {
      Object.keys(props).forEach(prop => {
        if (prop === "className" && props[prop]) {
          // always apply className and base
          str = str.trim();
          str += ` ${props[prop]}`;
          // eslint-disable-next-line
        } else if (props[prop] && styles.hasOwnProperty(prop)) {
          if (debug) console.log("styles", prop, props[prop], styles[prop]);

          str = str.trim();
          str += ` ${styles[prop]}`;
        }
      });
    }
  }

  if (debug) console.log("final.class", str.trim());

  return str.trim();
}
